import produce from 'immer';
import {
  DASHBOARD_AVAILABLE_BALANCE_REQUEST,
  DASHBOARD_MINTING_REQUEST,
  DASHBOARD_SUMMARY_REQUEST,
  DASHBOARD_USAGE_AND_DESTROY_REQUEST,
  NOTIFICATION_SETTING_INFO_REQUEST,
  NOTIFICATION_SETTING_UPDATE,
  SET_DASHBOARD_AVAILIABLE_BALANCE, SET_DASHBOARD_MINTING,
  SET_DASHBOARD_SUMMARY, SET_DASHBOARD_USAGE_AND_DESTROY, SET_NOTIFICATION_SETTING_INFO, SET_TOKEN_SEND_CONDITIONS_INFO,
  TOKEN_SEND_CONDITIONS_INFO_REQUEST, TOKEN_SEND_CONDITIONS_UPDATE, WALLET_RESPONSE_MESSAGE, XPER_MINT
} from '../../constants/wallet/walletConstants';

const initialState = {
  walletSymmary: {
    resultCode: 0,
    code: 'string',
    description: 'string',
    realtimeHvh: 0,
    realtimePer: 0,
    realtimeXper: 0,
    targetDate: new Date().toString(),
    availableBalanceHvh: 0,
    availableBalancePer: 0,
    availableBalanceXper: 0
  },
  availiableBalance: [],
  mintings: [],
  usageAndDestroy: [],
  notificationSettingInfo: {},
  tokenSendConditionsInfo: {},
  resultCode: null,
};

/* eslint-disable default-case, no-param-reassign */
const walletReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case DASHBOARD_SUMMARY_REQUEST:
    case DASHBOARD_AVAILABLE_BALANCE_REQUEST:
    case DASHBOARD_MINTING_REQUEST:
    case DASHBOARD_USAGE_AND_DESTROY_REQUEST:
    case NOTIFICATION_SETTING_INFO_REQUEST:
    case TOKEN_SEND_CONDITIONS_INFO_REQUEST:
    case TOKEN_SEND_CONDITIONS_UPDATE:
    case NOTIFICATION_SETTING_UPDATE:
    case XPER_MINT:
      // request
      break;
    case SET_DASHBOARD_SUMMARY:
      draft.walletSymmary = action.data;
      break;
    case SET_DASHBOARD_AVAILIABLE_BALANCE:
      draft.availiableBalance = action.data;
      break;
    case SET_DASHBOARD_MINTING:
      draft.mintings = action.data;
      break;
    case SET_DASHBOARD_USAGE_AND_DESTROY:
      draft.usageAndDestroy = action.data;
      break;
    case SET_NOTIFICATION_SETTING_INFO:
      draft.notificationSettingInfo = action.data;
      break;
    case SET_TOKEN_SEND_CONDITIONS_INFO:
      draft.tokenSendConditionsInfo = action.data;
      break;
    case WALLET_RESPONSE_MESSAGE:
      draft.resultCode = action.resultCode;
      break;
    default:
      break;
  }
});

export default walletReducer;
